import React, { Fragment, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Loader from './Layouts/Loader/Loader';
import "./index.scss";
import reportWebVitals from './reportWebVitals';
import Dashboard from './components/Dashboard/Dashboard';
import { AuthProvider } from './components/Authentication/AuthProvider';
import { Toaster } from 'react-hot-toast';

const Auth = lazy(() => import('./components/Authentication/firebaseAuth/auth'));
const App = lazy(() => import('./components/app'));
const Error400 = lazy(() => import('./components/Authentication/errorPage/Error400/Error400'));
const ErrorPages = lazy(() => import('./components/ErrorPages'));
const AuthLogin = lazy(() => import('./components/Authentication/firebaseAuth/AuthLogin'));
const SignUp = lazy(() => import('./components/Authentication/firebaseAuth/Signup'));

const Presensi = lazy(() => import('./components/Presensi/Presensi'));
const Nadine = lazy(() => import('./components/Nadine/Nadine'));
const NadineDetail = lazy(() => import('./components/Nadine/NadineDetail'));
const NadineForm = lazy(() => import('./components/Nadine/NadineForm'));
const MyTask = lazy(() => import('./components/MyTask/MyTask'));
const TaskDetail = lazy(() => import('./components/MyTask/TaskDetail'));
const Cuti = lazy(() => import('./components/Cuti/Cuti'));
const CutiRequest = lazy(() => import('./components/Cuti/CutiRequest'));
const Lembur = lazy(() => import('./components/Lembur/Lembur'));
const Announcement = lazy(() => import('./components/Announcement/Announcement'));
const AnnouncementConfig = lazy(() => import('./components/Announcement/AnnouncementConfig'));
const Profile = lazy(() => import('./components/Profile/Profile'));
const Notifications = lazy(() => import('./components/Notifications/Notifications'));
const PolicyPresensi = lazy(() => import('./components/Policy/PolicyPresensi'));
const Payroll = lazy(() => import('./components/Payroll/Payroll'));
const ReportPresensi = lazy(() => import('./components/Reports/ReportPresensi'));
const ReportCuti = lazy(() => import('./components/Reports/ReportCuti'));
const ReportLembur = lazy(() => import('./components/Reports/ReportLembur'));
const ReportKaryawan = lazy(() => import('./components/Reports/ReportKaryawan'));
const ReportTugas = lazy(() => import('./components/Reports/ReportTugas'));
const ReportSlipGaji = lazy(() => import('./components/Reports/ReportSlipGaji'));


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Fragment>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" reverseOrder={false} />
          <React.Suspense fallback={<Loader />}>
            <Routes>

            {/* Firebase Authentication */}

            <Route path={`${process.env.PUBLIC_URL}/`} element={<Auth />}>
              <Route index element={<AuthLogin />} />
              <Route path={`${process.env.PUBLIC_URL}/Authentication/firebaseAuth/login`} element={<AuthLogin />} />
              <Route path={`${process.env.PUBLIC_URL}/Authentication/firebaseAuth/SignUp`} element={<SignUp />} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/`} element={<App />}>
              <Route path={`${process.env.PUBLIC_URL}/dashboard`} element={<Dashboard />} />
              <Route path={`${process.env.PUBLIC_URL}/presensi`} element={<Presensi />} />
              <Route path={`${process.env.PUBLIC_URL}/nadine`} element={<Nadine />} />
              <Route path={`${process.env.PUBLIC_URL}/nadine/create`} element={<NadineForm />} />
              <Route path={`${process.env.PUBLIC_URL}/nadine/:id`} element={<NadineDetail />} />
              <Route path={`${process.env.PUBLIC_URL}/mytask`} element={<MyTask />} />
              <Route path={`${process.env.PUBLIC_URL}/mytask/:id`} element={<TaskDetail />} />
              <Route path={`${process.env.PUBLIC_URL}/cuti`} element={<Cuti />} />
              <Route path={`${process.env.PUBLIC_URL}/cuti/request`} element={<CutiRequest />} />
              <Route path={`${process.env.PUBLIC_URL}/lembur`} element={<Lembur />} />
              <Route path={`${process.env.PUBLIC_URL}/announcement`} element={<Announcement />} />
              <Route path={`${process.env.PUBLIC_URL}/announcement/config`} element={<AnnouncementConfig />} />
              <Route path={`${process.env.PUBLIC_URL}/profile`} element={<Profile />} />
              <Route path={`${process.env.PUBLIC_URL}/notifications`} element={<Notifications />} />
              <Route path={`${process.env.PUBLIC_URL}/policy/presensi`} element={<PolicyPresensi />} />
              <Route path={`${process.env.PUBLIC_URL}/payroll/:tab`} element={<Payroll />} />
              <Route path={`${process.env.PUBLIC_URL}/reports/presensi`} element={<ReportPresensi />} />
              <Route path={`${process.env.PUBLIC_URL}/reports/cuti`} element={<ReportCuti />} />
              <Route path={`${process.env.PUBLIC_URL}/reports/lembur`} element={<ReportLembur />} />
              <Route path={`${process.env.PUBLIC_URL}/reports/karyawan`} element={<ReportKaryawan />} />
              <Route path={`${process.env.PUBLIC_URL}/reports/tugas`} element={<ReportTugas />} />
              <Route path={`${process.env.PUBLIC_URL}/reports/slip-gaji`} element={<ReportSlipGaji />} />
            </Route>

            {/* Authentication Error Pages */}
            <Route path={`${process.env.PUBLIC_URL}`} element={<ErrorPages />}>
              <Route path={`${process.env.PUBLIC_URL}/authentication/errorpage/error400`} element={<Error400 />} />
              </Route>
          </Routes>
        </React.Suspense>
        </AuthProvider>
      </BrowserRouter>
    </Fragment>

  </React.StrictMode>

);
reportWebVitals();
